var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"v1.40.11"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/1.40.11";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs'

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN === 'disabled' ? '' : process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.ENV_NAME,
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: process.env.NODE_ENV === 'development' ? 0 : 0.002,
  sampleRate: process.env.NODE_ENV === 'development' ? 0 : 0.1,
  beforeSend: (event, hint) => {
    const error = hint.originalException
    if (event && error && (!event.fingerprint || event.fingerprint.length === 0)) {
      event.fingerprint = event.fingerprint ?? []
      if (error instanceof Error) {
        event.fingerprint.push(error.name)
        event.fingerprint.push(error.message)
      } else if (typeof error === 'string') {
        event.fingerprint.push(error)
      }
    }
    return event
  },
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
  /**
   * Ignores errors by string (partial) or by regex;
   *
   * https://docs.sentry.io/platforms/javascript/guides/react/configuration/filtering/#using-platformidentifier-nameignore-errors-
   *
   * There is also a Gist available that contains several common domains
   * and errors to ignore if we ever wanted to combine them.
   *
   * https://gist.github.com/impressiver/5092952
   */
  ignoreErrors: [
    'Blocked a restricted frame with origin',
    // Random plugins/extensions
    'top.GLOBALS',
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'http://tt.epicplay.com',
    "Can't find variable: ZiteReader",
    'jigsaw is not defined',
    'ComboSearch is not defined',
    'http://loading.retry.widdit.com/',
    'atomicFindClose',
    // Facebook borked
    'fb_xd_fragment',
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    'conduitPage',
    // Generic error code from errors outside the security sandbox
    // You can delete this if using raven.js > 1.0, which ignores these automatically.
    'Script error.',
  ],
  allowUrls: [
    /(fes|box-static|webapp-static)\.ca-kijiji-production\.classifiedscloud\.io/,
    /www\.kijiji\.ca/,
    /beta\.kijiji\.ca/,
  ],
  denyUrls: [
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Woopra flakiness
    /eatdifferent\.com\.woopra-ns\.com/i,
    /static\.woopra\.com\/js\/woopra\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    // Other plugins
    /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
    /tmx\.kijiji\.ca/,
  ],
})
